import { useCallback, useEffect, useRef, useState } from 'react';

import BaseService from '../../../../../services/BaseService';

import { normalizeEventoResumo } from '../utils/integracaoStatus';



export const useDigitacaoEventos = (

  nsmpId,

  {

    enabled = true,

    participacaoMode = 'ATIVO',

    userId = null,

    fallbackIntegracao = null,

  } = {},

) => {

  const [loading, setLoading] = useState(false);

  const [eventos, setEventos] = useState([]);

  const [integracao, setIntegracao] = useState(fallbackIntegracao);

  const [loadError, setLoadError] = useState(false);

  const fallbackRef = useRef(fallbackIntegracao);

  fallbackRef.current = fallbackIntegracao;



  const fetchEventos = useCallback(async () => {

    if (!nsmpId || !enabled) return;

    setLoading(true);

    setLoadError(false);

    try {

      const response = await BaseService.get({ url: `nsmps/${nsmpId}/digitacao-eventos` });

      const data = response.data || {};

      let list = data.eventos || data.items || [];

      if (participacaoMode === 'CONSULTA' && userId) {

        list = list.filter(

          (ev) => ev.digitador?.id === userId || ev.digitadorId === userId,

        );

      }

      setEventos(list.map(normalizeEventoResumo));

      setIntegracao(data.integracaoAtual || data.integracao || fallbackRef.current);

    } catch {

      setEventos([]);

      setIntegracao(fallbackRef.current);

      setLoadError(true);

    } finally {

      setLoading(false);

    }

  }, [nsmpId, enabled, participacaoMode, userId]);



  useEffect(() => {

    if (!enabled) {

      setEventos([]);

      setIntegracao(fallbackRef.current);

      setLoadError(false);

      return;

    }

    fetchEventos();

  }, [enabled, fetchEventos]);



  return {

    eventos,

    integracao,

    loading,

    loadError,

    refetch: fetchEventos,

  };

};



export default useDigitacaoEventos;


